import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import List from './list';
import { getNewsDataList } from '../../../../../../../services/indexApi';

class ExtraList extends React.PureComponent {
    static propTypes = {
        localKey: PropTypes.string,
        info: PropTypes.object,
    };

    state = {
        html: '',
    };

    async componentDidMount() {
        const { localKey } = this.props;
        const html = await getNewsDataList(localKey);

        this.setState({
            html,
        });
    }

    render() {
        const { html } = this.state;
        const { info } = this.props;

        info.content = html;

        return html !== '' ? (
            <Chip {...info}>
                <List />
            </Chip>
        ) : (
            ''
        );
    }
}

export default errorBoundary(ExtraList);
